/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import React from "react";
import classes from '@/app/components/brands/BrandsPageBuilderComponent/brandsPageBuilderComponentStyles.module.scss';
import dynamic from 'next/dynamic'
import LazyLoad from "@/app/components/LazyLoad";
const BrandsSliderCarousel = dynamic(() => import("@/app/components/brands/BrandsPageBuilderComponent/BrandsSliderCarousel"));
import BrandsGrid from "@/app/components/brands/BrandsPageBuilderComponent/BrandsGrid";


export type TBrandPageBuilderComponentItem = {
    brand_name:string,
    logo: string,
    logo_alt:string,
    logo_title:string,
    sort_order: string,
    url_slug: string,
}

const BrandsPageBuilderComponent = (props: {
    display_type:string,
    brands: TBrandPageBuilderComponentItem[],
    className?: string,
}) => {
    // console.log('BrandsPageBuilderComponent props:');
    // console.log(props);

    return <div className={`brands-pb-component-wrapper ${classes.wrapper}`}>
        {props.display_type === 'grid' ?
            <BrandsGrid brands={props.brands} />
            :
            <LazyLoad shiftBeforeLoad={300} className={classes.inner}>
                <BrandsSliderCarousel brands={props.brands} />
            </LazyLoad>
        }
    </div>
}

export default BrandsPageBuilderComponent;